<script setup lang="ts">
import { computed } from 'vue';
import { ICONS, type IconName } from '../icons/icons';

const props = withDefaults(
  defineProps<{
    name: IconName;
    size?: number | string;
    stroke?: number;
    label?: string;
  }>(),
  { size: 24, stroke: 1.9, label: '' },
);

const def = computed(() => ICONS[props.name]);
const dimension = computed(() =>
  typeof props.size === 'number' ? `${props.size}px` : props.size,
);
</script>

<template>
  <svg
    class="icon"
    :class="{ 'icon--fill': def.fill }"
    viewBox="0 0 24 24"
    :width="dimension"
    :height="dimension"
    :fill="def.fill ? 'currentColor' : 'none'"
    stroke="currentColor"
    :stroke-width="def.fill ? 0 : props.stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="props.label === '' ? 'presentation' : 'img'"
    :aria-hidden="props.label === '' ? 'true' : undefined"
    :aria-label="props.label === '' ? undefined : props.label"
    v-html="def.body"
  />
</template>

<style scoped>
.icon {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
